import styled from "styled-components";
import backgroundImage from "../../../images/muze-bg.png";

export const AuthInner = styled.div`
    max-width: 1130px;
    width: 100%;
    margin: 0 auto;
    @media (max-width: 768px) {
        padding: 0 20px;
        margin-bottom: 90px;
        overflow: auto;
        max-width: 100% !important;
    }
`;

export const AuthFormWrapper = styled.div`
    width: 50%;
    float: left;
    @media (max-width: 768px) {
        width: 100%;
    }
`;

export const AuthContent = styled.div`

    @media (min-width: 769px) {
        margin-right: 20px;
        width: calc(50% - 20px);
    }
    width: 50%;
    float: left;

    li {
        color: white;
        font-size: 18px;
    }

    @media (max-width: 768px) {
        width: 100%;
        margin-bottom: 25px;
    }
`;
export const AuthNav = styled.div`
    width: 100%;
    margin-top: 49px;
    margin-bottom: 102px;
    overflow: auto;


    @media (max-width: 768px) {

        margin-top: 40px;
        margin-bottom: 55px;
    }
`;
export const AuthContentHeader = styled.h2`
    font-size: 45px;
    font-weight: 700;
    line-height: 45px;
    color: white;
    margin-top: -7px;
    max-width: 492px;
    margin-bottom: 30px;

`;
export const AuthContentParagraph = styled.p`

    margin: 20px 0;
    font-size: 18px;
    line-height: 24px;
    color: white;
    max-width: 432px;
`;

export const AuthLoginLink = styled.a`
    float: right;
    color: white;
    font-size: 22px;
    line-height: 24px;
    text-decoration: none;


    @media (max-width: 768px) {
        display: none;
        margin-top: 20px;
        width: 100%;
    }
`;

export const MobileAuthLoginLink = styled.a`
    display: none;
    @media (max-width: 768px) {

        color: white;
        font-size: 22px;
        line-height: 24px;
        text-decoration: none;
        display: block;
        margin: 5px 0 30px;
        width: 100%;
    }
`;

export const RegistrationPanel = styled.div`

    display: ${(props) => (props.active ? 'block' : 'none')};
    position: relative;
`;

export const RegistrationPanelSubHeader = styled.h3`
    font-size: 18px;
    line-height: 21px;
    color: #8C8FA8;
    text-align: center;
    margin-top: -10px;
`;

export const RegistrationPanelHeader = styled.h2`
    color: #5562C0;
    text-align: center;
    font-size: 28.5px;
    line-height: 34px;
    font-weight: 700;
`;

export const GoBack = styled.a`
    font-size: 20px;
    color: #8C8FA8;
    float: left;
    margin-top: 17px;
    cursor: pointer;
    margin-left: 20px;
`;

export const Plan = styled.label`
    padding: 15px;
    padding-top: 42px;
    padding-bottom: 40px;
    border: 1px solid #CECEDC;
    overflow: auto;
    display: block;
    cursor: pointer;
    margin-bottom: 20px;
    position: relative;
    display: ${(props) => (!props.hidden ? 'block' : 'none')};
`;

export const SelectedPlan = styled.label`
    padding: 15px;
    padding-top: 12px;
    padding-bottom: 9px;
    overflow: hidden;
    display: block;
    cursor: pointer;
    margin-bottom: 20px;
    position: relative;
`;

export const PlanCheckbox = styled.input`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &:after {
        content: '';
        display: block;
        background: url(/images/unselected-checkbox.png);
        width: 31px;
        height: 31px;
        background-size: cover;
        position: absolute;
        top: -9px;
        left: -6px;
    }

    &:checked:after {
        background: url(/images/selected-checkbox.png);
    }
`;

export const PlanHeader = styled.h4`
    color: #5562C0;
    font-size: 27px;
    font-weight: 700;
    float: left;
    margin: 0;
    margin-left: 45px;
    width: 100%;
    text-transform: capitalize !important;
`;

export const PlanDescription = styled.p`
    color: #8C8FA8;
    font-size: 16px;
    float: left;
    margin: 0;
    margin-left: 45px;
    width: 100%;
`;

export const ChangePlan = styled.p`
    color: #8C8FA8;
    font-size: 16px;
    float: left;
    margin: 0;
    margin-left: 45px;
    width: 100%;
`;

export const PlanPrice = styled.p`
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 38px;
    color: #273644;
    font-weight: 700;
    margin: 0;
`;

export const PlanPriceSuperscript = styled.span`
    color: #A4A6B9;
    font-size: 18px;
    position: relative;
    top: -15px;
    left: -4px;
`;

export const PlanPriceMonth = styled.span`
    color: #A4A6B9;
    font-size: 16px;;
`;

export const BillingInput = styled.input`
    border: 1px solid #CECEDC;
    width: 100%;
    height: 48px;
    padding: 5px 10px;
    margin-bottom: 12px;

    font-size: 20px;
`;

export const StripeInputWrapper = styled.div`
    border: 1px solid #CECEDC;
    width: 100%;
    height: 48px;
    padding: 5px;
    padding-top: 14px;
    margin-bottom: 12px;
`;

export const BillingInputMedium = styled.input`
    border: 1px solid #CECEDC;
    width: 100%;
    height: 48px;
    padding: 5px;
    margin-bottom: 12px;
    width: 66.66%;
    float: left;
    margin-right: 10px;
    width: calc(66.66% - 10px);
    font-size: 20px;
`;

export const BillingInputSmall = styled.input`
    border: 1px solid #CECEDC;
    width: 100%;
    height: 48px;
    padding: 5px 10px;
    margin-bottom: 12px;
    width: 50%;
    float: left;
    font-size: 20px;
`;

export const RegistrationWrapper = styled.div`
    background-size: cover !important;
    width: 100%;
    height: 100%;
    background: url("${backgroundImage}") center center;
    position: fixed;
    top: 0 !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    overflow-y: scroll;
    padding-bottom: 25px;

    @media (max-width: 768px) {
        overflow-y: scroll;

        .terms-conditions {
            position: relative;
            bottom: auto;
            right: auto;
            text-align: right;
            display: block;
            margin-right: 20px;
            box-sizing: border-box;
            margin-bottom: 20px;
        }
    }
`;

export const BillingSelect = styled.select`
    border: 1px solid #CECEDC;
    height: 48px;
    padding: 5px 10px;
    margin-bottom: 12px;
    width: calc(50% - 10px);
    float: left;
    margin-left: 10px;
    font-size: 20px;
`;


export const TimezoneSelect = styled.select`
    border: 0;
    border-bottom: 1px solid #CECEDC;
    width: 100%;
    height: 48px;
    padding: 5px 10px;
    margin-bottom: 12px;
    float: left;
    font-size: large;
`;

export const TimezoneLabel = styled.label`

    color: gray;
    font-size: small;
`;

export const VideoWrapper = styled.div`

    position: relative;
    padding-bottom: 56.25%; /* 16:9 */
    height: 0;

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`;

export const YourselfLabel = styled.label`
    color: #5562C0;
    font-size: 23px;
    width: 100%;
    display: block;
    margin-bottom: 14px;
`;

export const YourselfSelect = styled.select`
    width: 100%;
    display: block;
    margin-bottom: 13px;
    height: 48px;
`;

export const YourselfMultiSelect = styled.select`
    width: 100%;
    display: block;
    margin-bottom: 13px;
    height: 48px;
`;

export const ReviewHeading = styled.h3`
    color: #5562C0;
    font-size: 17px;

`;

export const AccountInformation = styled.div`
    font-size: 21px;
    color: #8C8FA8;
`;

export const ReviewTotal = styled.div`
    color: #5562C0;
    font-size: 19px;
`;

export const ReviewContent = styled.p`
    margin: 0;
`;

export const ReviewStrong = styled.strong`
    font-weight: 700;
`;

export const FormError = styled.div`
    color: #842029;
    background-color: #f8d7da;
    border-color: #f5c2c7;
    border: 1px solid #f5c2c7;
    padding: 15px;
    margin-bottom: 15px;
`;
